// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"4d026563","473":"34a6e9c8","493":"64b82da9","823":"7b9cc445"}[chunkId] + ".chunk.js";
};